import { BodyBlockV2Item, StoreBodyBlock } from 'constants/enums';

export const revealBodyBlockInV2Order = (
  items: BodyBlockV2Item[],
  block: StoreBodyBlock
): { nextItems: BodyBlockV2Item[]; wasAlreadyVisible: boolean } => {
  const index = items.findIndex((it) => it.blocks.includes(block));
  if (index === -1) {
    return { nextItems: items, wasAlreadyVisible: true };
  }

  const item = items[index];
  if (item.isVisible) {
    return { nextItems: items, wasAlreadyVisible: true };
  }

  const updated: BodyBlockV2Item = { ...item, isVisible: true };
  const without = [...items.slice(0, index), ...items.slice(index + 1)];

  let insertAt = without.length;
  for (let i = without.length - 1; i >= 0; i--) {
    if (without[i].isVisible) {
      insertAt = i + 1;
      break;
    }
  }

  return {
    nextItems: [
      ...without.slice(0, insertAt),
      updated,
      ...without.slice(insertAt)
    ],
    wasAlreadyVisible: false
  };
};
